<div class="banner">
  <a routerLink="/search" aria-label="Show All Products"
    >Show All Our Products</a
  >
  <p>Discover our full collection and find the perfect pieces for you.</p>
</div>
